module.exports = "../images/pet-friendly.svg?v=f5ea54e";